function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
export { _classCallCheck as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/classCallCheck.js
// module id = ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
// module chunks = 1